// ui/game-over-position.js: BATCH B4b-1 U7.
//
// At 844x390 the centred game-over card covered the partner's plate and
// cut the trump label "Spades" to "Spade". On short landscape tables
// (the compact composition) the card moves to the free spot nearest the
// table's centre, clear of every plate, the trump badge and its label,
// and the score box, below the header. Other tables keep it centred.

import { trumpBadgeStackRect } from '../canvas/trump-badge.js';

const GAP = 8;
const STEP = 2;

/**
 * @param {import('../canvas/layout.js').TableLayout} layout
 * @param {any} state                        snapshot (for the badge spot)
 * @param {{x:number, y:number}} stage        the canvas's page position
 * @param {{w:number, h:number}} viewport
 * @param {{w:number, h:number}} card         the card's drawn size
 * @returns {{left:number, top:number}|null}  null: keep it centred (on a
 *   compact table this logs a console warning: no free spot was found)
 */
export function gameOverCardPosition(layout, state, stage, viewport, card) {
  if (!layout.compact) return null;
  const page = (r) => ({ x: r.x + stage.x - GAP, y: r.y + stage.y - GAP, w: r.w + 2 * GAP, h: r.h + 2 * GAP });
  // Restyle step 2: the cream table names its own obstacles (the seat
  // tags, the score blocks, the status row), in table coordinates.
  const obstacles = (/** @type {any} */ (layout).obstacles ?? [...layout.seats, layout.scoreboard, trumpBadgeStackRect(layout, state ?? {})])
    .filter(Boolean).map(page);
  const hits = (x, y) => obstacles.some((r) => x < r.x + r.w && r.x < x + card.w && y < r.y + r.h && r.y < y + card.h);
  const cx = stage.x + layout.canvasW / 2;
  const cy = stage.y + layout.canvasH / 2;
  /** @type {{left:number, top:number}|null} */
  let best = null;
  let bestD = Infinity;
  for (let y = Math.max(0, stage.y); y + card.h <= viewport.h; y += STEP) {
    for (let x = 0; x + card.w <= viewport.w; x += STEP) {
      if (hits(x, y)) continue;
      const d = Math.hypot(x + card.w / 2 - cx, y + card.h / 2 - cy);
      if (d < bestD) { bestD = d; best = { left: x, top: y }; }
    }
  }
  // The supported fallback: the dialog's own centring. Say so, since the
  // card may then cover a plate or the trump label.
  if (!best) {
    console.warn(`[game-over] no free spot clear of plates for a ${card.w}x${card.h} card on a ${viewport.w}x${viewport.h} screen; card centred and may cover a plate`);
  }
  return best;
}
